import { PaperCard } from 'components/cards/paper-card';
import { PropertiesMap } from 'components/PropertiesMap';
import { OrderProperty } from 'types/order';
import { useMediaQuery } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: any) => ({
  mapWrapper: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
}));

type MapOverviewSceneProps = {
  properties: OrderProperty[],
  selectProperty: (id: string) => void;
  selectedProperty: OrderProperty | undefined,
  onMapFeatureClick?: () => void,
  hideSelector?: boolean
};

export const MapOverviewScene = ({
  properties,
  selectProperty,
  selectedProperty,
  onMapFeatureClick,
  hideSelector = false,
}: MapOverviewSceneProps) => {
  const classes = useStyles();
  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down('md'));
  const mapHeight = isMobile ? '200px' : '320px';

  const handleSelectProperty = (id: string) => {
    selectProperty(id);
    if (onMapFeatureClick) {
      onMapFeatureClick();
    }
  };

  return (
    <PaperCard cardPadding={0}>
      <div className={classes.mapWrapper}>
        <PropertiesMap
          properties={properties}
          onSelectProperty={handleSelectProperty}
          selectedPropertyId={selectedProperty?._id ?? ''}
          direction="vertical"
          mapHeight={mapHeight}
          padding="0"
          mapInitZoom={4.5}
          mapFitZoomOut={isMobile ? 1 : 0}
          elevation={0}
          maxSeleceCharacterLength={200}
          hideSelector={hideSelector}
          squareMap
        />
      </div>
    </PaperCard>
  );
};
